import React from "react";
import { ContentLayout, Header, SpaceBetween } from "@cloudscape-design/components";
import { StepFunctionFailuresForm, StepFunctionFailuresResults } from "../Components";
import { ApiClient, StepFunctionFailuresService } from "../services";
import { useStepFunctionFailures } from "../hooks";
import { Stage, SFN_FAILURES_LABELS, NotifyFn, RealmLower } from "../constants";
import { FailedExecutionsQuery } from "../services/StepFunctionFailuresService";

interface StepFunctionFailuresPageProps {
  stage: Stage;
  onNotify: NotifyFn;
}

const service = new StepFunctionFailuresService(ApiClient.getInstance());
const listStateMachinesFn = (realm: RealmLower) => service.listStateMachines(realm);
const getFailedExecutionsFn = (realm: RealmLower, query: FailedExecutionsQuery) => service.getFailedExecutions(realm, query);

export const StepFunctionFailuresPage: React.FC<StepFunctionFailuresPageProps> = ({ stage, onNotify }) => {
  const {
    config,
    setConfig,
    stateMachines,
    stateMachinesStatus,
    reloadStateMachines,
    loading,
    result,
    searchedContext,
    handleSearch,
  } = useStepFunctionFailures({
    onNotify,
    listStateMachinesFn,
    getFailedExecutionsFn,
  });

  return (
    <ContentLayout
      header={
        <Header variant="h1" description={SFN_FAILURES_LABELS.PAGE_DESCRIPTION}>
          {SFN_FAILURES_LABELS.PAGE_TITLE}
        </Header>
      }
    >
      <SpaceBetween size="l">
        <StepFunctionFailuresForm
          config={config}
          stage={stage}
          loading={loading}
          stateMachines={stateMachines}
          stateMachinesStatus={stateMachinesStatus}
          onConfigChange={setConfig}
          onReloadStateMachines={reloadStateMachines}
          onSubmit={handleSearch}
        />
        {result && searchedContext && <StepFunctionFailuresResults result={result} searchedContext={searchedContext} />}
      </SpaceBetween>
    </ContentLayout>
  );
};
